$(document).ready(function () {
    /**
     * VideoJS
     * show button 2 minutes after video starts
     */
    if ($('#watch').hasClass('hero--vsl')) {
        videojs('vsl-video').ready(function () {
            this.on('timeupdate', function () {
                if (this.currentTime() >= (60 * 2) || this.currentTime() == this.duration()) {
                    $('.hero .cta-wrap').addClass('show');
                }
                // console.log(this.currentTime());
            })
        });
    }

    /**
     * Scroll to Cart
     */
    if ($('#salesBanner').length) {
        let salesBannerHeight = Math.floor($('#salesBanner').height());

        if ($('#salesBanner').hasClass('isSticky')) {
            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top - salesBannerHeight
                }, 1000);
            });
        } else {
            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top
                }, 1000);
            });
        }
    } else {
        let bannerHeight = Math.floor($('.BF-banner').height());

        $('.btn:not(.cta), .BF-banner').on('click', function (event) {
            if ($('body').hasClass('BF')) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top - bannerHeight
                }, 1000);
            } else {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top
                }, 1000);
            }
        });
    }

    $('.stickyCTA .btn').on('click', ctaActivateSS);

    function ctaActivateSS() {
        if ($('.stickyCTA .btn').attr('data-sscart') === 'true') {
            handleSubscribe('forceSubscribe');
        };
    }

    /**
     * Cart Slick for mobile
     */
    $('.cart__cards').slick({
        mobileFirst: true,
        variableWidth: false,
        slidesToShow: 1,
        dots: true,
        speed: 300,
        centerMode: true,
        centerPadding: '50px',
        slidesToShow: 1,
        initialSlide: 1,
        responsive: [
            {
                breakpoint: 360,
                settings: {
                    centerPadding: '22%',
                }
            },
            {
                breakpoint: 445,
                settings: {
                    centerPadding: '25%',
                }
            },
            {
                breakpoint: 530,
                settings: {
                    centerPadding: '28%',
                }
            },
            {
                breakpoint: 767,
                settings: 'unslick'
            }

        ]
    });

    /**
     * Handle products
     */
    function activeProduct() {
        let thisProduct = $(this);
        // console.log(thisProduct);

        const subscribe = $('#orderNow').attr('data-check');

        const retail = thisProduct.attr('data-retail');
        let amount, link, shipping, checkboxType;

        // console.log(subscribe);

        if (subscribe === 'subscribe') {
            amount = 'data-subscribe-amount';
            link = 'data-subscribe-tracker';
            shipping = 'data-subscribe-shipping';
            checkboxType = true;

        } else {
            amount = 'data-amount';
            link = 'data-tracker';
            shipping = 'data-shipping';
            checkboxType = false;
        }

        // console.log(thisProduct.attr(amount));
        // console.log(retail);
        // console.log((retail - thisProduct.attr(amount)).toFixed(2));

        //- Load given prices
        thisProduct.find('.amount__value').html(thisProduct.attr(amount));
        thisProduct.find('.shipping__value').html(thisProduct.attr(shipping));

        //- Calculate saving value
        thisProduct.find('.save__value').html(
            (retail - thisProduct.attr(amount)).toFixed(2)
        );

        $('#orderNow').find('.purchaseMode__input').attr("checked", checkboxType);

        //- load tracker + param
        let param = thisProduct.find('.cta.btn').attr('data-param');
        thisProduct.find('.cta').attr('href', (thisProduct.attr(link) + param));
    };

    /**
     * Control Subscribe Mode
     */
    $('.purchaseMode__input').on('click', function (check) {
        handleSubscribe(this);
        // console.log($(this).is(":checked"));
    });
    
    function handleSubscribe(thisEL) {
        let checkboxType;
        
        if (thisEL == 'forceSubscribe') {
            checkboxType = true;
            $('#orderNow').attr('data-check', 'subscribe').find('.purchaseMode__input').attr("checked", checkboxType);

            // console.log($('.purchaseMode__input').is(":checked"));
            
        } else {
            if ($('#orderNow').attr('data-check') === 'un-subscribe') {
                checkboxType = true;
                $('#orderNow').attr('data-check', 'subscribe');
                
            } else {
                checkboxType = false;
                $('#orderNow').attr('data-check', 'un-subscribe')
            }

            thisEL.setAttribute('checked', checkboxType);
        }

        $('.card').each(activeProduct);
    }

    $('.card').each(activeProduct);

    /**
     * Reviews Slick
     */
    $('#reviewsList').slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        speed: 700,
        adaptiveHeight: true,
        centerMode: false
    });

    /**
     * Consume section Slick
     */
    $('#consumeSlider').slick({
        mobileFirst: true,
        variableWidth: false,
        dots: true,
        arrows: true,
        speed: 300,
        adaptiveHeight: true,
        centerMode: false,
        slidesToShow: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 574,
                settings: 'unslick'
            }
        ]
    });

    //- About Video Dots Animation
    let num = 0;
    function timeoutDotsAnimation() {
        setTimeout(function () {
            const el = $('#aboutVidAnim .about-video__item');
            // console.log('num', num);
            (num === 5) ? num = 1 : num++;

            el.removeClass('about-video__item--anim');
            $('#aboutVidAnim .about-video__item[data-num=' + num + ']').addClass('about-video__item--anim');
            timeoutDotsAnimation();
        }, 3000);
    }

    timeoutDotsAnimation();

    /**
     * Featured On Carousel Banner
     */
    if ($('#featuredOnList').length) {
        $('#featuredOnList').slick({
            autoplay: true,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 7
                    }
                },
                {
                    breakpoint: 850,
                    settings: "unslick"
                }
            ]
        });
    }

    //- Set current Year to footer Copyright
    let thisDate = new Date();
    $('#year').html(thisDate.getFullYear());
});
